export const ICON_CATEGORIES = {
  "Animals":  ["🐶","🐱","🦊","🐼","🐨","🦁","🐯","🐮","🦄","🐸","🐧","🦋"],
  "Sports":   ["⚽","🏀","🎾","🏊","🏈","⚾","🎯","🏆","🥊","🏄","🤸","⛷️"],
  "Nature":   ["🌸","🌊","🌙","⭐","🌺","🌻","🌈","⚡","❄️","🔥","🌿","🍀"],
  "Space":    ["🚀","🌍","🌟","🪐","☄️","🌠","🛸","🔭","🌌","💫","🌙","☀️"],
  "Food":     ["🍕","🍩","🎂","🍦","🍓","🍔","🌮","🍜","🧁","🍭","🍪","🍉"],
  "Fantasy":  ["🦄","🐉","🧙","🦸","🧝","🧜","🧚","🔮","⚔️","🛡️","🪄","👑"],
};

export const EMOJI_CATEGORIES = [
  { label: "⭐ Popular",      emojis: ["⭐","🏆","🎁","🎉","🎊","🥇","💝","👑","💎","🌟","✨","🔥","💯","🎯","🚀","❤️","🧡","💛","💚","💙","💜","🖤","🤍","🎈","🎀"] },
  { label: "🎮 Fun & Games",  emojis: ["🎮","🕹️","🎲","🎯","🎳","🎪","🎡","🎢","🃏","🀄","🎭","🎨","🖌️","🎸","🎹","🎵","🎶","🎤","🎧","🎬","📺","📱","💻","🖥️","⌨️"] },
  { label: "🍕 Food & Treats",emojis: ["🍕","🍔","🍟","🌮","🌯","🍩","🍦","🎂","🍫","🍬","🍭","🧁","🥤","🍿","🧇","🥞","🍰","🍪","🍿","🥨","🍜","🍣","🍱","🥗","🍎","🍓","🍇","🍑","🥝","🍋"] },
  { label: "😴 Downtime",     emojis: ["😴","💤","🛋️","🛁","🌙","🌛","🌜","⭐","🌠","🌌","🏖️","🏝️","🧸","📚","📖","🎭","🎠","🎡","🌺","🌸","🌻","🌹","🌷","🍀","🌈"] },
  { label: "🏃 Activities",   emojis: ["⚽","🏀","🏈","⚾","🎾","🏐","🏉","🎱","🏓","🏸","🥊","🏊","🤸","🚴","⛷️","🏋️","🧗","🤺","🏇","🤼","🥋","⛺","🎣","🤿","🎿","🛹","🛼","🏄","🧘","🤾"] },
  { label: "🚀 Adventure",    emojis: ["🚀","✈️","🚂","🚢","🏎️","🚁","🛸","🌍","🗺️","🏔️","🗻","🌋","🏕️","🎠","🎡","🎢","🎪","🎭","🎟️","🎫","🌅","🌄","🌠","🎑","🎆","🎇"] },
  { label: "🐾 Animals",      emojis: ["🐶","🐱","🐭","🐹","🐰","🦊","🐻","🐼","🐨","🐯","🦁","🐸","🐵","🐔","🐧","🐦","🦆","🦅","🦉","🦇","🐺","🐗","🐴","🦄","🦋","🐛","🐌","🐞","🐝","🦗"] },
  { label: "💝 Special",      emojis: ["💝","🎁","🛍️","💰","🪙","👑","💎","🏅","🎗️","🏵️","🎖️","🥇","🥈","🥉","🏆","🎪","🎠","🎡","🎢","🎯","🎳","🎲","🎭","🎨","🖼️"] },
  { label: "😊 Faces",        emojis: ["😀","😃","😄","😁","😆","😅","😂","🤣","😊","😇","🙂","🙃","😉","😌","😍","🥰","😘","😗","😙","😚","😋","😛","😜","🤪","😝","🤑","🤗","🤭","😎","🥸"] },
];

export const EMOJI_SEARCH_INDEX = [
  ["star","award","gold","win","trophy","best"],          ["⭐","🏆","🥇","🎖️","🌟","✨"],
  ["gift","present","reward","shop","buy"],                ["🎁","🛍️","💝","🎀","🎊"],
  ["fire","hot","lit","amazing","great"],                  ["🔥","💯","⚡","✨","🌟"],
  ["game","play","fun","controller","video"],              ["🎮","🕹️","🎲","🃏","🎯"],
  ["food","eat","pizza","burger","yum"],                   ["🍕","🍔","🍟","🌮","🍩"],
  ["sweet","candy","dessert","cake","treat"],              ["🍫","🍬","🍭","🎂","🧁","🍪","🍦"],
  ["sleep","rest","nap","tired","relax","chill"],          ["😴","💤","🛋️","🌙","💆"],
  ["sport","ball","soccer","basketball","game"],           ["⚽","🏀","🏈","🎾","🏓"],
  ["swim","swim","surf","water","beach","pool"],           ["🏊","🏄","🤿","🏖️","🌊"],
  ["run","bike","cycle","active","exercise","gym"],        ["🚴","🏃","🤸","🏋️","⛹️"],
  ["rocket","space","fly","travel","adventure"],           ["🚀","✈️","🛸","🌍","🗺️"],
  ["animal","pet","dog","cat","cute"],                     ["🐶","🐱","🦊","🐻","🐼"],
  ["heart","love","cute","sweet","valentines"],            ["❤️","💝","💕","🥰","😍"],
  ["crown","king","queen","royal","winner"],               ["👑","💎","🏅","🥇","⭐"],
  ["happy","smile","laugh","fun","lol"],                   ["😀","😂","🤣","😄","😁"],
  ["cool","sunglasses","awesome","sick","rad"],            ["😎","🤙","🔥","💯","✌️"],
  ["music","song","sing","dance","beat"],                  ["🎵","🎶","🎤","🎧","🎸"],
  ["movie","film","watch","cinema","tv"],                  ["🎬","📺","🎭","🍿","🎟️"],
  ["book","read","study","school","learn"],                ["📚","📖","✏️","🖊️","📝"],
  ["money","cash","coins","rich","spend"],                 ["💰","🪙","💵","🏦","💳"],
  ["unicorn","magic","fantasy","dream","fairy"],           ["🦄","🌈","✨","🧚","⭐"],
];
